'use strict';

frontendApp.factory('TagCategoryService', ['$resource', '$rootScope', '$q', 'ConfigService', 'ResourceWrapperService', function ($resource, $rootScope, $q, ConfigService, ResourceWrapperService) {

  var _service = {
    categories: []
  };

  var hasCache = function () {
    return !_.isEmpty(_service.categories);
  };

  var RawTagCategoryResource = $resource(ConfigService.getServerBaseUrlForResource() + '/tagCategory/:id',
    {'id': '@id'});

  var TagCategory = ResourceWrapperService.WrapActions(RawTagCategoryResource);

  _service.findAll = function (callback) {
    _service.categories = TagCategory.query({}, function (categories) {
      $rootScope.$broadcast('TagCategoryService.update', categories);
      if (callback) callback(categories);
    });
    return _service.categories;
  };

  _service.findProjectCategory = function (callback) {
    return _service.findByName('Project', callback);
  };

  _service.findSystemCategory = function (callback) {
    return _service.findByName('System', callback);
  };

  _service.findDomainCategory = function (callback) {
    return _service.findByName('Domain', callback);
  };

  _service.findByName = function (name, callback) {
    var deferred = $q.defer();
    var promise = deferred.promise;
    var category;

    promise.then(function (category) {
      if (callback) callback(category);
    });

    if (hasCache()) {
      // I've already fetched all of the tags, so just filter out
      // the one we need
      category = _.findWhere(_service.categories, {name: name});
      deferred.resolve(category);
    } else {
      // I need to fetch all projects
      _service.findAll(function (categories) {
        category = _.findWhere(categories, {name: name});
        deferred.resolve(category);
      });
    }

    return promise;
  };

  _service.findById = function (id, callback) {
    var deferred = $q.defer();
    var promise = deferred.promise;
    var category;

    promise.then(function (category) {
      if (callback) callback(category);
    });

    if (hasCache()) {
      // I've already fetched all of the tags, so just filter out
      // the one we need
      category = _.findWhere(_service.categories, {id: id});
      deferred.resolve(category);
    } else {
      // I need to fetch all projects
      _service.findAll(function (categories) {
        category = _.findWhere(categories, {id: id});
        deferred.resolve(category);
      });
    }

    return promise;
  };


  return _service;

}]);
